import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader hasFooter bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_5 = { class: "d-flex flex-wrap" }
const _hoisted_6 = { class: "d-flex flex-wrap" }
const _hoisted_7 = { class: "fs_12 d-block" }
const _hoisted_8 = { class: "footerButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$opModal.closeLast()))
      }, [
        _hoisted_3
      ]),
      _createVNode(_component_localized_text, {
        class: "fs_12 greyBlue",
        localizedKey: "app_filtri",
        text: "Filtri"
      }),
      _hoisted_4
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mb-2",
      localizedKey: "app_tipologia",
      text: "Tipologia"
    }),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", {
        class: ["filterTab", _ctx.localSelectedTypeList.length == 0 ? 'active' : ''],
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.localSelectedTypeList = []))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_tutti",
          text: "Tutti"
        })
      ], 2),
      _createVNode("div", {
        class: ["filterTab", _ctx.isTypeSelected('community')],
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleType('community')))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_community",
          text: "Community"
        })
      ], 2),
      _createVNode("div", {
        class: ["filterTab", _ctx.isTypeSelected('event')],
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleType('event')))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_eventi",
          text: "Eventi"
        })
      ], 2),
      _createVNode("div", {
        class: ["filterTab", _ctx.isTypeSelected('fiera')],
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleType('fiera')))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_fiere",
          text: "Fiere"
        })
      ], 2)
    ]),
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mb-2 mt-3",
      localizedKey: "app_topic",
      text: "Topic"
    }),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", {
        class: ["filterTab", _ctx.localSelectedCategoryList.length == 0 ? 'active' : ''],
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.localSelectedCategoryList = []))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_12 d-block",
          localizedKey: "app_tutti",
          text: "Tutti"
        })
      ], 2),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (cat, i) => {
        return (_openBlock(), _createBlock("div", {
          class: ["filterTab", _ctx.isCategorySelected(cat.name)],
          key: i,
          onClick: ($event: any) => (_ctx.toggleCategory(cat.name))
        }, [
          _createVNode("span", _hoisted_7, _toDisplayString(cat.name), 1)
        ], 10, ["onClick"]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("button", {
        class: "genericButton bgGreyBlue w-100",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter()))
      }, [
        _createVNode(_component_localized_text, {
          class: "fs_14 white",
          localizedKey: "app_filtra",
          text: "Filtra"
        })
      ])
    ])
  ]))
}